"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerExecutorSchema = void 0;
const zod_1 = require("zod");
exports.TriggerExecutorSchema = zod_1.default.object({
    executorType: zod_1.default.string(),
});
//# sourceMappingURL=trigger-executor.js.map